<template>
  <div class="mountain-area-legend" v-if="showLegend">
    <div class="category category--difficulty" v-if="showCategoryDifficulty">
      <div class="title">{{ $t('Difficulty') }}</div>
      <div class="item item--easy" v-if="showGreenCircle">
        <img
          :src="require('@/assets/icons/ratings/easy.svg')"
          alt="Easy Icon"
          class="icon icon--easy"
        />
        <div class="label">{{ trailDifficultyMappings["Easy"] }}</div>
      </div>
      <div class="item item--intermediate" v-if="showBlueSquare">
        <img
          :src="require('@/assets/icons/ratings/intermediate.svg')"
          alt="Intermediate Icon"
          class="icon icon--intermediate"
        />
        <div class="label">{{ trailDifficultyMappings["Intermediate"] }}</div>
      </div>
      <div class="item item--advanced-intermediate" v-if="showBlueBlackSquare">
        <img
          :src="require(`@/assets/icons/ratings/advanced_intermediate.svg`)"
          alt="Advanced Intermediate Icon"
          class="icon icon--advanced-intermediate"
        />
        <div class="label">{{ trailDifficultyMappings["Advanced Intermediate"] }}</div>
      </div>
      <div class="item item--advanced-intermediate" v-if="showBlueBlueSquare">
        <img
          :src="require(`@/assets/icons/ratings/bluebluesquare.svg`)"
          alt="Advanced Intermediate Icon"
          class="icon icon--advanced-intermediate"
        />
        <div class="label">{{ trailDifficultyMappings["Advanced Intermediate"] }}</div>
      </div>
      <div class="item item--advanced" v-if="showBlackDiamond">
        <img
          :src="require('@/assets/icons/ratings/advanced.svg')"
          alt="Difficult Icon"
          class="icon icon--advanced"
        />
        <div class="label">{{ trailDifficultyMappings["Difficult"] }}</div>
      </div>
      <div class="item item--expert" v-if="showDoubleBlackDiamond">
        <img
          :src="require(`@/assets/icons/ratings/expert.svg`)"
          alt="Expert Icon"
          class="icon icon--expert"
        />
        <div class="label">{{ trailDifficultyMappings["Expert"] }}</div>
      </div>
      <div class="item item--expert" v-if="showExtremeTerrain">
        <img
          :src="require('@/assets/icons/ratings/extreme-terrain.svg')"
          alt="Extreme Terrain Icon"
          class="icon icon--extreme-terrain"
        />
        <div class="label">{{ trailDifficultyMappings["Extreme Terrain"] }}</div>
      </div>
      <div class="item item--terrainpark" v-if="showPark">
        <img
          :src="require('@/assets/icons/ratings/park.svg')"
          alt="Terrain Park Icon"
          class="icon icon--terrainpark"
        />
        <div class="label">{{ trailDifficultyMappings["Park"] }}</div>
      </div>

      <div class="item item--adventurezone" v-if="showAdventureZone">
        <img
          :src="require('@/assets/icons/ratings/purple_star.svg')"
          alt="Adventure Zone Icon"
          class="icon icon--adventurezone"
        />
        <div class="label">{{ $t("Adventure Zone") }}</div>
      </div>

      <div class="item item--greenfreeride" v-if="showGreenFreeride">
        <img
          :src="require('@/assets/icons/ratings/mtnbike/green_freeride.svg')"
          alt="Green Freeride Icon"
          class="icon icon--greenfreeride"
        />
        <div class="label">{{ trailDifficultyMappings["Green Freeride"] }}</div>
      </div>
      <div class="item item--greentechnical" v-if="showGreenTechnical">
        <img
          :src="require('@/assets/icons/ratings/mtnbike/green_technical.svg')"
          alt="Green Technical Icon"
          class="icon icon--greentechnical"
        />
        <div class="label">{{ trailDifficultyMappings["Green Technical"] }}</div>
      </div>

      <div class="item item--bluefreeride" v-if="showBlueFreeride">
        <img
          :src="require('@/assets/icons/ratings/mtnbike/blue_freeride.svg')"
          alt="Blue Freeride Icon"
          class="icon icon--bluefreeride"
        />
        <div class="label">{{ trailDifficultyMappings["Blue Freeride"] }}</div>
      </div>
      <div class="item item--bluetechnical" v-if="showBlueTechnical">
        <img
          :src="require('@/assets/icons/ratings/mtnbike/blue_technical.svg')"
          alt="Blue Technical Icon"
          class="icon icon--bluetechnical"
        />
        <div class="label">{{ trailDifficultyMappings["Blue Technical"] }}</div>
      </div>

      <div class="item item--blackfreeride" v-if="showBlackFreeride">
        <img
          :src="require('@/assets/icons/ratings/mtnbike/black_freeride.svg')"
          alt="Black Freeride Icon"
          class="icon icon--blackfreeride"
        />
        <div class="label">{{ trailDifficultyMappings["Black Freeride"] }}</div>
      </div>
      <div class="item item--blacktechnical" v-if="showBlackTechnical">
        <img
          :src="require('@/assets/icons/ratings/mtnbike/black_technical.svg')"
          alt="Black Technical Icon"
          class="icon icon--blacktechnical"
        />
        <div class="label">{{ trailDifficultyMappings["Black Technical"] }}</div>
      </div>

      <div class="item item--doubleblackfreeride" v-if="showDoubleBlackFreeride">
        <img
          :src="require('@/assets/icons/ratings/mtnbike/doubleblack_freeride.svg')"
          alt="Double Black Freeride Icon"
          class="icon icon--doubleblackfreeride"
        />
        <div class="label">{{ trailDifficultyMappings["DoubleBlack Freeride"] }}</div>
      </div>
      <div class="item item--doubleblacktechnical" v-if="showDoubleBlackTechnical">
        <img
          :src="require('@/assets/icons/ratings/mtnbike/doubleblack_technical.svg')"
          alt="Double Black Technical Icon"
          class="icon icon--doubleblacktechnical"
        />
        <div class="label">{{ trailDifficultyMappings["DoubleBlack Technical"] }}</div>
      </div>
    </div>

    <div class="category category--grooming" v-if="showCategoryGrooming">
      <div class="title">{{ $t("Grooming") }}</div>
      <div class="item item--grooming" v-if="showGrooming">
        <img
          :src="require('@/assets/icons/grooming.svg')"
          alt="Grooming Icon"
          class="icon icon--grooming"
        />
        <div class="label">{{ $t("Grooming") }}</div>
      </div>
      <div class="item item--groomingtop" v-if="showGroomingTop">
        <img
          :src="require('@/assets/icons/grooming_top.svg')"
          alt="Grooming Top Icon"
          class="icon icon--groomingtop"
        />
        <div class="label">{{ $t("Grooming Top") }}</div>
      </div>
      <div class="item item--groomingbottom" v-if="showGroomingBottom">
        <img
          :src="require('@/assets/icons/grooming_bottom.svg')"
          alt="Grooming Bottom Icon"
          class="icon icon--groomingbottom"
        />
        <div class="label">{{ $t("Grooming Bottom") }}</div>
      </div>
      <div class="item item--groomingfirstshift" v-if="showGroomingFirstShift">
        <img
          :src="require('@/assets/icons/grooming_first_shift.svg')"
          alt="Grooming First Shift Icon"
          class="icon icon--groomingfirstshift"
        />
        <div class="label">{{ $t("Grooming First Shift") }}</div>
      </div>
      <div class="item item--groomingsecondshift" v-if="showGroomingSecondShift">
        <img
          :src="require('@/assets/icons/grooming_second_shift.svg')"
          alt="Grooming Second Shift Icon"
          class="icon icon--groomingsecondshift"
        />
        <div class="label">{{ $t("Grooming Second Shift") }}</div>
      </div>
      <div class="item item--snowmaking" v-if="showSnowmaking">
        <img
          :src="require('@/assets/icons/snowmaking.svg')"
          alt="Snowmaking Icon"
          class="icon icon--snowmaking"
        />
        <div class="label">{{ $t("Snowmaking") }}</div>
      </div>
      <div class="item item--nightsnowmaking" v-if="showNightSnowmaking">
        <img
          :src="require('@/assets/icons/snowmaking_overnight.svg')"
          alt="Night Snowmaking Icon"
          class="icon icon--nightsnowmaking"
        />
        <div class="label">{{ $t("Night Snowmaking") }}</div>
      </div>
    </div>

    <div class="category category--features" v-if="showCategoryFeatures">
      <div class="title">{{ $t('Features') }}</div>
      <div class="item item--moguls" v-if="showMoguls">
        <img
          :src="require('@/assets/icons/moguls.svg')"
          alt="Moguls Icon"
          class="icon icon--moguls"
        />
        <div class="label">{{ trailDifficultyMappings["Moguls"] }}</div>
      </div>
      <div class="item item--mogulstop" v-if="showMogulsTop">
        <img
          :src="require('@/assets/icons/moguls_top.svg')"
          alt="Moguls Top Icon"
          class="icon icon--mogulstop"
        />
        <div class="label">{{ trailDifficultyMappings["Moguls Top"] }}</div>
      </div>
      <div class="item item--mogulsbottom" v-if="showMogulsBottom">
        <img
          :src="require('@/assets/icons/moguls_bottom.svg')"
          alt="Moguls Bottom Icon"
          class="icon icon--mogulsbottom"
        />
        <div class="label">{{ trailDifficultyMappings["Moguls Bottom"] }}</div>
      </div>
      <div class="item item--glades" v-if="showGlades">
        <img
          :src="require('@/assets/icons/glades.svg')"
          alt="Glades Icon"
          class="icon icon--glades"
        />
        <div class="label">{{ $t("Glades") }}</div>
      </div>
      <div class="item item--snowshoeing" v-if="showSnowshoeing">
        <img
          :src="require('@/assets/icons/snowshoeing.svg')"
          alt="Snowshoeing Icon"
          class="icon icon--snowshoeing"
        />
        <div class="label">{{ $t("Snowshoeing") }}</div>
      </div>
      <div class="item item--touring" v-if="showTouring">
        <img
          :src="require(`@/assets/icons/${touringIcon}.svg`)"
          alt="Touring Icon"
          class="icon icon--touring"
        />
        <div class="label">{{ trailDifficultyMappings["Touring"] }}</div>
      </div>

      <div class="item item--nordic" v-if="showNordic">
        <img
          :src="require('@/assets/icons/nordic.svg')"
          alt="Nordic Icon"
          class="icon icon--nordic"
        />
        <div class="label">{{ trailDifficultyMappings["Nordic"] }}</div>
      </div>
    </div>

    <div class="category category--status" v-if="showCategoryStatus">
      <div class="title">Status</div>
      <div class="item item--race" v-if="showRace">
        <img
          :src="require('@/assets/icons/race_in_progress.svg')"
          alt="Race Icon"
          class="icon icon--race"
        />
        <div class="label">{{ $t("Race In Progress") }}</div>
      </div>
      <div class="item item--nightskiing" v-if="showNightSkiing">
        <img
          :src="require('@/assets/icons/nightskiing.svg')"
          alt="Night Skiing Icon"
          class="icon icon--nightskiing"
        />
        <div class="label">{{ $t("Night Skiing") }}</div>
      </div>
      <div class="item item--groomers-choice" v-if="showGroomersChoice">
        <img
          :src="require('@/assets/icons/groomers_choice.svg')"
          alt="Groomer's Choice Icon"
          class="icon icon--groomers-choice"
        />
        <div class="label">{{ $t("Groomer's Choice") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Legend',
  computed: {
    ...mapGetters([
      'activeMountainAreaTrails',
      'mtnAreaToggles',
      'customIcons',
      'resortSluggedName',
      'trailDifficultyMappings',
    ]),
    showCategoryDifficulty() {
      return true; // always show Difficulty category
    },
    showLegend() {
      return this.activeMountainAreaTrails && this.mtnAreaToggles.legendValue;
    },
    showCategoryGrooming() {
      return (
        this.showGrooming
        || this.showGroomingTop
        || this.showGroomingBottom
        || this.showGroomingFirstShift
        || this.showGroomingSecondShift
        || this.showSnowmaking
        || this.showNightSnowmaking
      );
    },
    showCategoryFeatures() {
      return (
        this.showMoguls
        || this.showMogulsTop
        || this.showMogulsBottom
        || this.showGlades
        || this.showSnowshoeing
        || this.showTouring
        || this.showNordic
      );
    },
    showCategoryStatus() {
      return this.showRace || this.showNightSkiing || this.showGroomersChoice;
    },
    showGreenCircle() {
      return this.checkTrailIcon('GreenCircle');
    },
    showGreenBlackCircle() {
      return this.checkTrailIcon('GreenBlackCircle');
    },
    showGreenCircleBlackSquare() {
      return this.checkTrailIcon('GreenCircleBlackSquare');
    },
    showBlueSquare() {
      return this.checkTrailIcon('BlueSquare');
    },
    showBlueBlackSquare() {
      return this.checkTrailIcon('BlueBlackSquare');
    },
    showBlueBlueSquare() {
      return this.checkTrailIcon('BlueBlueSquare');
    },
    showBlackDiamond() {
      return this.checkTrailIcon('BlackDiamond');
    },
    showDoubleBlackDiamond() {
      return this.checkTrailIcon('DoubleBlackDiamond');
    },
    showModeratelyDifficult() {
      return this.checkTrailIcon('Moderately Difficult');
    },
    showAdvancedIntermediate() {
      return this.checkTrailIcon('Advanced Intermediate');
    },
    showDifficult() {
      return this.checkTrailIcon('Difficult');
    },
    showVeryDifficult() {
      return this.checkTrailIcon('Very difficult');
    },
    showExpert() {
      return this.checkTrailIcon('Expert');
    },
    showExtremeTerrain() {
      return this.checkTrailIcon('ExtremeTerrain');
    },
    showPark() {
      return this.checkTrailIcon('Park');
    },
    showPurpleStar() {
      return this.checkTrailIcon('PurpleStar');
    },
    showAdventureZone() {
      return this.checkTrailsDifficulty('Adventure Zone');
    },
    showGreenFreeride() {
      return this.checkTrailIcon('GreenFreeride');
    },
    showGreenTechnical() {
      return this.checkTrailIcon('GreenTechnical');
    },
    showBlueTechnical() {
      return this.checkTrailIcon('BlueTechnical');
    },
    showBlueFreeride() {
      return this.checkTrailIcon('BlueFreeride');
    },
    showBlackTechnical() {
      return this.checkTrailIcon('BlackTechnical');
    },
    showBlackFreeride() {
      return this.checkTrailIcon('BlackFreeride');
    },
    showDoubleBlackTechnical() {
      return this.checkTrailIcon('DoubleblackTechnical');
    },
    showDoubleBlackFreeride() {
      return this.checkTrailIcon('DoubleblackFreeride');
    },
    showGrooming() {
      return this.checkTrailsFor('Grooming', 'Yes');
    },
    showGroomingTop() {
      return this.checkTrailsFor('Grooming', 'Top');
    },
    showGroomingBottom() {
      return this.checkTrailsFor('Grooming', 'Bottom');
    },
    showGroomingFirstShift() {
      return this.checkTrailsFor('Grooming', 'First Shift');
    },
    showGroomingSecondShift() {
      return this.checkTrailsFor('Grooming', 'Second Shift');
    },
    showSnowmaking() {
      return this.checkTrailsFor('SnowMaking', 'Yes');
    },
    showNightSnowmaking() {
      return this.checkTrailsFor('SnowMaking', 'Overnight');
    },
    showMoguls() {
      return this.checkTrailsFor('Moguls', 'Yes');
    },
    showMogulsTop() {
      return this.checkTrailsFor('Moguls', 'Top');
    },
    showMogulsBottom() {
      return this.checkTrailsFor('Moguls', 'Bottom');
    },
    showGlades() {
      return this.checkTrailsFor('Glades', 'Yes');
    },
    showSnowshoeing() {
      return this.checkTrailIcon('Snowshoe');
    },
    showTouring() {
      return this.checkTrailsFor('Touring', 'Yes');
    },
    touringIcon() {
      if (this.customIcons.indexOf('touring') >= 0) {
        return `resorts/${this.resortSluggedName}/touring`;
      }

      return 'touring';
    },
    mediumParksIcon() {
      // Tremblant ONLY wants to show a 'parks icon' not one per size
      if (this.customIcons.indexOf('parks') >= 0) {
        return `resorts/${this.resortSluggedName}/ratings/parks`;
      }

      return 'ratings/terrain_park_medium';
    },
    showNordic() {
      return this.checkTrailsFor('Nordic', 'Yes');
    },
    showRace() {
      return this.checkTrailsFor('StatusEnglish', 'closed_race_in_progress');
    },
    showNightSkiing() {
      return this.checkTrailsFor('NightSkiing', 'Yes');
    },
    showGroomersChoice() {
      return this.checkTrailsFor('StatusEnglish', 'groomers_choice');
    },
  },
  methods: {
    checkTrailsDifficulty(difficulty) {
      const trails = this.activeMountainAreaTrails;
      let hasDifficulty = false;

      for (let i = 0; i < trails.length; i++) {
        const trailDifficulty = this.lookupDifficulty(trails[i].Difficulty);
        if (trailDifficulty === difficulty) {
          hasDifficulty = true;
          break;
        }
      }

      return hasDifficulty;
    },
    checkTrailIcon(iconName) {
      const trails = this.activeMountainAreaTrails;
      let hasIcon = false;

      for (let i = 0; i < trails.length; i++) {
        if (trails[i].TrailIcon === iconName) {
          hasIcon = true;
          break;
        }
      }

      return hasIcon;
    },
    lookupDifficulty(difficulty) {
      // The feed can have things like 'easier' for 'easy'
      if (difficulty === 'Easier') { return 'Easy'; }

      return this.$t(difficulty);
    },
    lookupDifficultyFrench(difficulty) {
      return difficulty;
    },
    checkTrailsFor(key, value) {
      const trails = this.activeMountainAreaTrails;
      let hasKey = false;

      for (let i = 0; i < trails.length; i++) {
        const trail = trails[i];
        if (trail[key] === value) {
          hasKey = true;
          break;
        }
      }

      return hasKey;
    },
  },
};
</script>

<style lang="scss" scoped>
#dashboard {
  .mountain-area-legend {
    background-color: $legend-background;
    display: none;
    padding: 20px 35px;
    @media (min-width: $tablet) {
      display: block;
      margin-top: -30px;
    }
    .category {
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
      display: flex;
      flex-direction: row;
      padding-bottom: 20px;
      margin-bottom: 20px;
      &:last-child {
        border-bottom: none;
      }

      .title {
        color: $white;
        font-family: $base-font-semibold;
        font-size: 18px;
        font-weight: bold;
        flex: 0 0 auto;
        margin-top: 1.5%;
        opacity: 0.8;
        text-transform: uppercase;
        width: 15%;
      }

      .item {
        flex: 0 1 160px;
        margin: 0 2.5% 0 0;
        text-align: center;
        @media (min-width: $tablet-landscape) {
          margin: 0 4% 0 0;
        }

        .icon {
          display: block;
          height: auto;
          margin: 0 auto;
          max-width: initial;
          position: relative;
          width: 85px;
        }
        .label {
          color: $white;
          font-family: $base-font-regular;
          font-size: 18px;
          line-height: 1.2;
          opacity: 0.5;
        }
      }
    }
  }
}
</style>

<i18n locale="fr-ca">
{
  "Snowmaking": "Neige fabriquée",
  "Grooming": "Damé",
  "Grooming Top": "Damé haut",
  "Grooming Bottom": "Damé bas",
  "Moguls": "Bosses",
  "Moguls Top": "Bosses haut",
  "Moguls Bottom": "Bosses bas",
  "Facile": "Easy",
  "Difficile": "Difficult",
  "Difficile": "Moderately Difficult",
  "Intermédiaire": "Intermediate",
  "Très difficile": "Very difficult",
  "Extrême": "Extreme Terrain",
  "Petit modules": "SmallPark",
  "Moyens modules": "MediumPark",
  "Grands modules": "LargePark",
  "Glades": "Sous-bois",
  "Snowshoe": "Sentiers de randonnée",
  "Touring": "Sentiers de randonnée",
  "Difficulty": "Niveau de Difficulté",
  "Features": "Profil"
}
</i18n>
